import Vue from 'vue';
import Vuex from 'vuex';

import rfq from '@/store/modules/rfq';
import axios from 'axios';
import cookie from 'vue-cookies';
import { USER_TYPE } from '@/utils/const';
import renewal from '@/store/modules/renewal';
import renewalReminders from '@/store/modules/renewalReminders';
import auth from './modules/auth';
import payments from './modules/payments';
import personalDataTravel from './modules/personalDataTravel';
import portalCache from './modules/portalCache';
import referral from './modules/referral';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    client: [],
    clientLoading: true,
    notification: {},
    policy: '',
  },
  getters: {
    clientData: (state) => (state.client.length === 0 ? null : state.client[0]),
    notificationCount: (state) => ('MOTOR' in state.notification ? state.notification.MOTOR : 0) || 0,
  },
  mutations: {
    setClient(state, payload) {
      state.clientLoading = false;
      state.client = payload;
    },
    updateNotification(state, payload) {
      state.notification = payload;
    },
    updatePolicy(state, payload) {
      state.policy = payload;
    },
  },
  actions: {
    getNotificationCount: (context) => {
      if (cookie.get(USER_TYPE) === 'agent') return Promise.resolve();
      return context.dispatch('portalCache/fetchCustomerNotifications');
    },
    getPolicy: async (context, param) => {
      await axios.get(`/customer/gis/policies/details?policyNo=${param}`)
        .then((response) => {
          context.commit('updatePolicy', response.data.object);
        });
    },
  },
  modules: {
    auth,
    rfq,
    renewal,
    renewalReminders,
    payments,
    personalDataTravel,
    portalCache,
    referral,
  },
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
